export const getTranslations = async (locale: string) => {
    const {
        mylounge,
        header,
        footer,
        cart,
        upcoming,
        platformJourney,
        deprecationWarning,
        catalog,
        homepage,
    } = await import(
        /* webpackPreload: true */
        /* webpackChunkName: "[request]" */
        `./${locale}.json`
    );

    return {
        ...mylounge,
        ...footer,
        ...header,
        ...cart,
        ...upcoming,
        ...platformJourney,
        ...deprecationWarning,
        ...catalog,
        ...homepage,
        locale: locale.replace('_', '-'),
    };
};
